// extracted by mini-css-extract-plugin
export default {"textDark":"Login_textDark__rHX5v","textLight":"Login_textLight__jlGfh","headerText":"Login_headerText__Z0Ck5"};